import { render, staticRenderFns } from "./RatingDescription.vue?vue&type=template&id=14a0b294&scoped=true"
import script from "./RatingDescription.vue?vue&type=script&lang=js"
export * from "./RatingDescription.vue?vue&type=script&lang=js"
import style0 from "./RatingDescription.vue?vue&type=style&index=0&id=14a0b294&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a0b294",
  null
  
)

export default component.exports